// *********** NOTE - CSS is maintained in CDN for date picker.  Any issues, make sure that file does not need to be updated! **************
import React from "react";
import labelPlugin from "flatpickr/dist/plugins/labelPlugin/labelPlugin.js";
import DateTimePicker from "react-flatpickr";
import {
    convertToDateTimePickerFormat,
    convertToDateTimeString,
    convertToTimeString,
} from "../../Utilities/Types/dateUtilities";
import {DisplayField, InputClear} from ".";
import {DateTimePickerType} from "./inputConstants";
import {InputLayout} from "./InputLayout";
import {createFakeEvent} from "./inputUtility";
import type {ChangeHandler} from "../../types";

export interface DateTimePickerFieldProps {
ariaLabel?: string;
dateTimePickerType?: number;
disabled?: boolean;
error?: string;
label: string;
labelClass?: string;
large_columns?: string;
medium_columns?: string;
name?: string;
onChange?: ChangeHandler;
    showClear?: boolean;
    value?: string;
    type?: string;
    setValue?: (value: string) => void;
    setError?: (error: string) => void;
}

export const DateTimePickerField: React.FC<DateTimePickerFieldProps> = ({
                                        ariaLabel = "",
                                        disabled = false,
                                        dateTimePickerType = DateTimePickerType.Calendar,
                                        error,
                                        label,
                                        labelClass,
                                        large_columns,
                                        medium_columns,
                                        name,
                                        onChange,
                                        showClear = true,
                                        value = "",
                                    }: DateTimePickerFieldProps) => {

    const flatPickrDisplayTimeFormat = "h:i K";
    const flatPickrDisplayDateFormat = "m/d/Y";
    const invalidDate = "Invalid date";
    const isValidDate = !!value && value !== invalidDate;
    const enableTime = dateTimePickerType !== DateTimePickerType.Calendar;
    const noCalendar = dateTimePickerType === DateTimePickerType.TimeOnly;
    const altFormat = noCalendar ? flatPickrDisplayTimeFormat : enableTime ? `${flatPickrDisplayDateFormat} ${flatPickrDisplayTimeFormat}` : flatPickrDisplayDateFormat;

    const handleChange = (_dateObject: Date[], dateString: string) => {
        dateString = !value && noCalendar
            ? getInitialTimeOnlyValueHack()
            : dateString;

        onChange?.(createFakeEvent(dateString, name ?? ''));
    };

    const getInitialTimeOnlyValueHack = () => {
        return "12:00";
    };

    const clearDate = () => {
        onChange?.(createFakeEvent("", name ?? ''));
    };

    const options = {
        altFormat: altFormat,
        allowInput: true,
        altInput: true,
        noCalendar: noCalendar,
        enableTime: enableTime,
        onChange: handleChange,
        onClose: handleChange,
        plugins: [labelPlugin()],
        onReady: (_a: Date[], _b: string, fp: { calendarContainer: HTMLElement; altInput: HTMLInputElement }) => {
            fp.altInput.setAttribute("aria-label", ariaLabel ? ariaLabel : label);
            fp.altInput.setAttribute("autocomplete", `off`);
        }
    };

    let formatDateTime = "";
    if (isValidDate) {
        const useMilitaryTime = !disabled;
        formatDateTime = noCalendar
            ? convertToTimeString(value, useMilitaryTime)
            : disabled
                ? convertToDateTimeString(value, enableTime)
                : convertToDateTimePickerFormat(value, enableTime);
    }

    const editBar = !disabled && showClear && isValidDate
        ? <InputClear
            inputDescription={`date for ${label}`}
            onClick={clearDate}
        />
        : <></>;

    const result = disabled ?
        <DisplayField
            displayClass={`datepicker-container`}
            label={label}
            name={name ?? ''}
            value={formatDateTime}
        />
        :
        <InputLayout
            disabled={disabled}
            error={error}
            label={label}
            labelClass={labelClass}
            large_columns={large_columns}
            medium_columns={medium_columns}
            name={name ?? ''}
        >
            <div className={`datepicker-container`}>
                <DateTimePicker id={name} value={formatDateTime} options={options}/>
                {editBar}
            </div>
        </InputLayout>

    return result;
};
